import React from 'react';
import { Form } from 'semantic-ui-react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './LoginForm.form';
import { Auth } from '../../../../api';
import { useAuth } from '../../../../hooks';
import './LoginForm.scss';
import { useState } from 'react';

const authController = new Auth();

export function LoginForm() {

    const { login } = useAuth();
    const [error, setError] = useState('');

    const formik = useFormik({
        initialValues: initialValues(),
        validationSchema: validationSchema(),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            try {
                console.log(formValue);
                const response = await authController.login(formValue);

                if (!login) {
                    setError('Incorrect UserName or Password. Pleae, try again.')
                } else {
                    authController.setAccessToken(response.accessToken);
                    authController.setRefreshToken(response.refreshToken);

                    login(response.accessToken);
                }

            } catch (error) {
                console.error(error);
                setError('Error to authenticate. Please, try again.')
            }
        },
    });

  return (
    <div className='login'>
        <Form className='login__form' onSubmit={formik.handleSubmit}>
            <h1 className='login__form-h1'>BackOffice</h1>
            <p className='login__form-p'>Log in with your email</p>
            <Form.Input
                type='text'
                name='username'
                label='User Name'
                placeholder='name@company.com'
                onChange={formik.handleChange}
                value={formik.values.username}
                error={formik.errors.username}
            />

            <Form.Input
                type='password'
                name='password'
                label='Password'
                placeholder='password'
                onChange={formik.handleChange}
                value={formik.values.password}
                error={formik.errors.password}
            />

            <Form.Button className='login__form-button' type='submit' primary loading={formik.isSubmitting}>
                {'Log in'}
            </Form.Button>

            {error && <p>{error}</p>}
        </Form>
    </div>
  );
}
